import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=5af21ef7&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/login.css?vue&type=style&index=0&id=5af21ef7&prod&scoped=true&lang=css&external"
import style1 from "./sign.vue?vue&type=style&index=1&id=5af21ef7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af21ef7",
  null
  
)

export default component.exports